import { tasksId } from "../types/activityTasks";
import { imagesIntroTema1 } from "../types/tema1ImagesMenuIntroduction";

const getAllImages = {
	...imagesIntroTema1
}


export const menuActiIntroduction = () => {
	return Object.values(tasksId).map((topic) => {
		const images = Object.values(topic.activities)
			.flatMap((activity) => getAllImages[activity] || [])
		return {
			id: topic.id,
			title: topic.title,
			images,
		};
	})
}